import { userManager } from 'helpers/authentication'
import PropTypes from 'prop-types'
import Button from '../../../../../shared/Button/Button'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './MiniLogInCta.scss'

const redirectToLogIn = (e) => {
  e.preventDefault()
  localStorage.setItem('authReturnUrl', window.location.href)
  userManager.signinRedirect()
}

const LogInCta = ({ t, tReady, loginText }) => (
  <div className="c-mini-log-in-cta">
    <div className="c-mini-log-in-cta__content">
      <div className="c-mini-log-in-cta__heading">
        {loginText || t('project.accounts-cta.heading')}
      </div>
      <Button type="secondary" onClick={redirectToLogIn} text={tReady && t('project.accounts-cta.button')} />
    </div>
  </div>
)

LogInCta.propTypes = {
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
  loginText: PropTypes.string,
}

export default withNamespaces('translations')(LogInCta)
